import React from 'react';
import { LuDownload, LuLoader } from 'react-icons/lu';

import { Button } from '@/components/ui/button';

import { DateRange } from './date-ranges';
import { useExportQuarterlyReview } from './export';

interface ReportingExportButtonProps {
    globalAccountGUID: string;
    range: DateRange;
    selectedAccountGUIDs: string[];
    includeClosed: boolean;
}

export const ReportingExportButton = ({
    globalAccountGUID,
    range,
    selectedAccountGUIDs,
    includeClosed,
}: ReportingExportButtonProps) => {
    const { mutate, isPending, isError } = useExportQuarterlyReview({
        globalAccountGUID,
        range,
        selectedAccountGUIDs,
        includeClosed,
    });

    return (
        <div className="flex flex-col items-end">
            <Button
                onClick={() => mutate()}
                disabled={isPending}
                className="bg-cocoa-900 hover:bg-cocoa-800 rounded-lg font-medium text-white"
            >
                {isPending ? (
                    <LuLoader className="mr-2 h-4 w-4 animate-spin" />
                ) : (
                    <LuDownload className="mr-2 h-4 w-4" />
                )}
                Export
            </Button>
            {isError ? <span className="text-negative mt-1 text-xs">Export failed — try again.</span> : null}
        </div>
    );
};
